<template>
  <div class="vhp-empty" :class="{ full: fullScreen }">
    <div v-if="showImage" class="empty-image">
      <img src="@/assets/image/no-image.png" class="image">
    </div>
    <div class="empty-text">{{ !text ? this.$t("콘텐츠없음") : text }}</div>
  </div>
</template>

<script>
export default {
  props: {
    text: {
      type: String,
      default: "",
    },
    fullScreen: {
      type: Boolean,
      default: false,
    },
    showImage: {
      type: Boolean,
      default: false,
    }
  },
  data() {
    return {};
  },
  mounted() {},
};
</script>

<style lang="scss" src="./vhpEmpty.scss"></style>
